import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { usePathname } from '@/i18n/navigation';
import { isRummyActiveAtom } from '@/app/[locale]/(main)/(non-activity)/rummy/store';
import { isCasinoInGameAtom } from '@/store/casino';
import { inPlayPages } from '@/const/page-url';

/**
 * 检测用户是否在游戏场景中
 * Detect if user is in game scenario
 *
 * 游戏场景包括：Rummy、Casino 或 in-play 页面
 * Game scenario includes: Rummy, Casino, or in-play pages
 * 注意：Fantasy 游戏金钱变化较小，不包含在内
 * Note: Fantasy game has small money changes, not included
 *
 * @returns 包含 isInGame 布尔值的对象 (Object with isInGame boolean)
 *
 * @example
 * ```typescript
 * const { isInGame } = useGameScenario();
 * usePollingInterval(isInGame ? 5000 : 10000);
 * ```
 */
export function useGameScenario() {
  const pathname = usePathname();
  const isRummyActive = useAtomValue(isRummyActiveAtom);
  const isCasinoInGame = useAtomValue(isCasinoInGameAtom);

  const isInGame = useMemo(() => {
    // 检查是否在 Rummy 或 Casino 游戏中
    // Check if in Rummy or Casino game
    if (isRummyActive || isCasinoInGame) {
      return true;
    }
    // 检查 URL 是否匹配游戏页面
    // Check if URL matches game pages
    return inPlayPages.some(str => pathname.includes(str));
  }, [pathname, isRummyActive, isCasinoInGame]);

  return { isInGame };
}
